import { render, staticRenderFns } from "./RegistrationConfirm.vue?vue&type=template&id=a5112dec&scoped=true"
import script from "./RegistrationConfirm.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirm.vue?vue&type=script&lang=js"
import style0 from "./RegistrationConfirm.vue?vue&type=style&index=0&id=a5112dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5112dec",
  null
  
)

export default component.exports